// @mui material components
import {Tooltip, Typography } from '@mui/material';
import { MDBox } from '../MDBox';
import { IClickableCell } from './RowAction';

interface IClickableCellProps {
    value: IClickableCell
}

export function ClickableCell({ value } : IClickableCellProps) {
return (    
    <MDBox display="flex" justifyContent="center" alignItems="center" px={0}>
        <Tooltip title={value.label}>
            <Typography variant="caption" lineHeight={1} sx={{ cursor: "pointer", mx: 0 }} fontWeight='regular' color="#007bff" component="a" onClick={() => {value.action(value.key)}}>{value.label}</Typography>
        </Tooltip>
    </MDBox >
)}